import { useContext } from 'react'

import { Chip } from '@h2/components/display/chip'
import { OccupationsIcon } from '@h2/components/icons/occupations'
import { CertificationIcon } from '@h2/components/icons/certification'
import { CollegeIcon } from '@h2/components/icons/college'
import { ClusterIcon, MajorIcon, JobsIcon } from '@h2/components/icons'
import { GroupsIcon } from '@h2/components/icons/groups'
import { ProgramIcon } from '@h2/components/icons/program'
import { Globals } from '@h2/globals'

const icons = {
  major: MajorIcon,
  college: CollegeIcon,
  onet: OccupationsIcon,
  certification: CertificationIcon,
  cluster: ClusterIcon,
  navigator: GroupsIcon,
  program: ProgramIcon,
  externaljobopening: JobsIcon
}
const colors = {
  parent: 'red',
  teacher: 'blue',
  System: 'green',
  Headed2: 'green'
}
/*
 * there are instances where names might have different keys (result of legacy components), so we can
 * use this to normalize.
 */
const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1)
const OutputChip = ({ text, recBy, shouldCapitalize, ...rest }) => {
  const { clusterTaxonomyShortTitle } = useContext(Globals)
  const translateTypes = {
    onet: 'occupation',
    externaljobopening: 'job opening',
    cluster: clusterTaxonomyShortTitle
  }
  const translatedText = translateTypes[text] || text
  const chipColor = recBy ? colors[recBy] || 'blue' : 'gray'
  const icon = text ? icons[text] : null
  const value = shouldCapitalize ? capitalize(translatedText) : translatedText

  return (
    <Chip align="right" color={chipColor} icon={icon} {...rest}>
      {value}
    </Chip>
  )
}

export { OutputChip }
